<app-header></app-header>
<div class="main-layout-container">
  <div class="main-content-container">
    <router-outlet />
  </div>
  <app-footer></app-footer>
</div>
<app-bottom-nav></app-bottom-nav>